export const PICTOGRAM_HELP_SUPPORT =
  "https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_help-support_x-reverse.svg";
export const PICTOGRAM_QUICK_SIGN_UP =
  "https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_quick-sign-up.svg";

export const content = {
  heading: "Still need help?",
  loginTitle: "Log in to My Account",
  loginDescription: "Get the help you need without the wait",
  getInContactTitle: "Contact us",
  getInContactDescription:
    "Leave feedback, make a complaint or find other ways to get in touch",
};
